import { useCallback, useState } from "react";
import "./index.scss";

export const BrandDescription = ({
  brandName,
  description,
  defaultMaximumLines
}) => {
  const [maximumLines, setMaximumLines] = useState(defaultMaximumLines);
  const isExpanded = maximumLines === null;
  const toggleShowMore = useCallback(() => {
    isExpanded ? setMaximumLines(defaultMaximumLines) : setMaximumLines(null);
  }, [isExpanded, defaultMaximumLines]);
  const toggleMessage = `see ${isExpanded ? "less" : "more"}`;
  const title = `Buy ${brandName} Gift Cards & Coupons`;

  return (
    <div className="brand-description" data-testid="brand-description">
      <h1 className="brand-title">{title}</h1>
      <p
        className="description-sidebar"
        style={{
          WebkitLineClamp: maximumLines
        }}
      >
        {description}
      </p>
      <span className="show-more" onClick={toggleShowMore}>
        {toggleMessage}
      </span>
    </div>
  );
};
